<template>
  <div class="reactions_wrap">
    <button
      v-on:click="() => sendReaction(reaction)"
      v-for="reaction in reactions"
      v-bind:key="reaction.id"
      class="hover_op"
    >
      <img
        width="32"
        v-bind:src="reaction.svg"
        v-bind:alt="`Reaction ${reaction.name}`"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: "Reactions",
  data() {
    return {
      reactions: [
        {
          id: "emoji_u1f60e",
          name: "Smiling Face with Sunglasses",
          svg: `${process.env.BASE_URL}emojis/emoji_u1f60e.svg`,
        },
        {
          id: "emoji_1f389",
          name: "Party Popper",
          svg: `${process.env.BASE_URL}emojis/emoji_1f389.svg`,
        },
        {
          id: "emoji_u1f60d",
          name: "Heart eyes",
          svg: `${process.env.BASE_URL}emojis/emoji_u1f60d.svg`,
        },
        {
          id: "emoji_u1f44d",
          name: "Thumbs up",
          svg: `${process.env.BASE_URL}emojis/emoji_u1f44d.svg`,
        },
        {
          id: "emoji_u1f602",
          name: "Laughing",
          svg: `${process.env.BASE_URL}emojis/emoji_u1f602.svg`,
        },
      ],
    };
  },
  methods: {
    sendReaction(reaction) {
      this.$store.dispatch("sendReaction", reaction);
    },
  },
};
</script>

<style lang="scss" scoped>
.reactions_wrap {
  position: absolute;
  z-index: 1;
  top: -126px;
  right: 0;
  border-radius: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.16);
  padding: 32px;

  @media all and (max-width: 767px) {
    position: relative;
    top: 0;
    padding: 0;
    box-shadow: none;
    justify-content: center;
  }

  &::before {
    content: "";
    position: absolute;
    display: block;
    width: 150px;
    height: 50px;
    right: 0;
    top: 85%;

    @media all and (max-width: 767px) {
      display: none;
    }
  }
}

button {
  width: 48px;
  height: 48px;
  flex: none;
  transition: transform 180ms;
  transform: scale(1);

  @media all and (max-width: 767px) {
    width: 32px !important;
    height: 32px !important;
    margin-top: 0 !important;
    padding: 0 !important;
    margin-bottom: 16px;

    & + button {
      margin-left: 8px !important;
    }
  }

  img {
    width: 100%;
    object-fit: contain;
    object-position: center;
    height: 100%;
  }

  & + button {
    margin-left: 16px;
  }

  &:active {
    transition: transform 180ms;
    transform: scale(1.1);
  }
}
</style>
